export enum EHidratacaoQueimadoType {
  Electrical = 'ELETRICO',
  Thermal = 'TERMICO',
}
